import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import {
	CRow,
	CCol,
	CContainer,
	CForm,
	CFormInput,
	CInputGroup,
	CInputGroupText,
	CFormSelect,
	CButton,
	CImage,
	CCard,
	CCardHeader,
	CCardBody,
	CCardFooter,
	CSpinner,
	CLink,
	CDropdown,CDropdownItem,CDropdownToggle,CDropdownMenu,
	CTooltip,
} from '@coreui/react';
import CIcon from '@coreui/icons-react'
import * as FileSaver from "file-saver";
import XLSX from "sheetjs-style";
import { isMobile } from "react-device-detect";
import {
	MyDialogform,
	MyPagination,
} from '../components/index'
import { Konfirm } from '../helpers/onConfirm'
import { UFunc,cAngkaTgl,cBulanPendek,cBulanPanjang } from '../helpers/functions'

const pjson 		= require('../../package.json')
const Lapterapi	= (props) => {
	const {
		setLoading,showToast,prosesExpired,setSessionaktif
	} = props; 

	//--DOM--/
	const uNavigate 			= useNavigate();
	const uDispatch 			= useDispatch();
	//--END DOM--/

	const uBahasaObj  				= useSelector(state => state.listBahasa);
	const uActiveroute  			= useSelector(state => state.activeRoute);
	const uSettingObj 				= useSelector(state => state.gListUserSetting);
	const uIsScrollBottom			= useSelector(state => state.gIsScrollBottom);
	const uEfekapp					= useSelector(state => state.effectApp);
	const [uEfekview,setEfekview] 	= React.useState(false);
	const uMaxData					= isMobile ? (uSettingObj.jml_mobile || 25) : (uSettingObj.jml_laporan || 100);
	const uTokenObj					= JSON.parse(localStorage.getItem("token")||"{}");
	const uSystemsettingObj			= useSelector(state => state.gSystemsetting);
	const uSelisihrangetanggal 		= useSelector(state => state.gSelisihrangetanggal);
	
	const uHeaderActionObj  		= useSelector(state => state.gInitHeaderAction);
	const uHandelView 				= uHeaderActionObj.isHeaderView || false;
	const uHandelReset 				= uHeaderActionObj.isHeaderreset || false;

	//--VIEWS_VARS--/
	const [uHtml500msg,setHtml500msg]	= React.useState(); 
	const uIsHapusallow					= (uTokenObj.userhak==="FREEROLE"||uTokenObj.userhak==="ADMIN") ? true : false;
	const [uIsDataloaded,setDataloaded]	= React.useState(false); 
	const [uCaptionObj,setCaptionObj]	= React.useState({}); 
	const [uFilterObj,setFilterObj]		= React.useState({});
	const [uFirstload,setFirstload]		= React.useState("YA");
	const [uSortedObj,setSortedObj]		= React.useState({});
	//const uFilterObj		  		= useSelector(state => state.gFilterObj) || {};

	const [uTimeelapse,setTimeelapse]	= React.useState(0); 
	const [uJmlData,setJmlData]			= React.useState(0);
	const [uPageActive,setPageActive]	= React.useState(1);
	const [uJmlHal,setJmlHal]			= React.useState(1);
	const [uRowselect,setRowselect]		= React.useState(-1);
	const [uIDselect,setIDselect]		= React.useState(0);

	const uDatacabangArr				= JSON.parse(localStorage.getItem("cabanglist")||"[]")
	const [uDatadefaultArr,setDatadefaultArr]= React.useState([]);
	const [uDatamainArr,setDatamainArr]	= React.useState([]);
	const [uTerapimainArr,setTerapimainArr]= React.useState([]); 
	const [uDatasumArr,setDatasumObj]	= React.useState({});
	const [uEfekview2,setEfekview2] 	= React.useState(false);
	//--END VIEWS_VARS--*/

	//--FORM_VARS--/
	const [uIsDlgformshow,setDlgformshow]	= React.useState(false);
	const [uHeaderDlgform,setHeaderDlgform]	= React.useState("");
	const [uFormdataObj,setFormdataObj]		= React.useState({});
	//--END FORM_VARS--/

	//--DOM_VARS--/
	const uElJmlData					= document.getElementById("idjmldata");
	const [uElBtnsimpan,setElBtnsimpan]	= React.useState(document.getElementById("btnDialogSimpan"));
	const fileType 		= "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
	const fileExtension = ".xlsx";
	//--END DOM_VARS--/

	//--SETTING_CETAK--/
	const uSettingcetakObj		= JSON.parse(localStorage.getItem("settingnota")) || {};
	const uHTMLstylelaporan		= useSelector(state => state.gHTMLstyleLaporan);
	const uFrameExport 			= document.getElementById("ifmcontentstoprint");
	//--END SETTING_CETAK--/

	//--HANDEL--/
	const hdlToggleDlgform = () => { setDlgformshow(false) }
	const hdlKlikDlgsimpan = () => {
		//--VALIDASI_FILTER--/
		let vElfocus	= document.getElementById("inpcabangid");
		if(parseInt(uFormdataObj.cabang_id||"0") <= 0) {
			vElfocus && vElfocus.focus();
			showToast("Cabang Harus Dipilih !");
			return
		}
		vElfocus	= document.getElementById("inpjenis");
		if((uFormdataObj.jenis||"").trim() !== "TAHUN"
			&& (uFormdataObj.jenis||"").trim() !== "BULAN"
			&& (uFormdataObj.jenis||"").trim() !== "TANGGAL") {
			vElfocus && vElfocus.focus();
			showToast("Jenis Periode Laporan Tidak Valid !");
			return
		}

		let vTanggal;
		if((uFormdataObj.jenis||"").trim() === "TAHUN") {
			vElfocus	= document.getElementById("inptahun");
			vTanggal  	= uFormdataObj.thn+"-01-01"; 
			if(!UFunc.isDateValid(vTanggal)) {
				vElfocus && vElfocus.focus();
				showToast("Periode Tahun Laporan Tidak Valid ! "); return
			}
		} else if((uFormdataObj.jenis||"").trim() === "BULAN") {
			vElfocus	= document.getElementById("inpbulanid");
			vTanggal  	= uFormdataObj.thn+"-"+uFormdataObj.bln+"-01"; 
			if(!UFunc.isDateValid(vTanggal)) {
				vElfocus && vElfocus.focus();
				showToast("Periode Bulan-Tahun Laporan Tidak Valid !"); return
			}
		} else {
			vElfocus	= document.getElementById("inptglawal");
			vTanggal  	= uFormdataObj.tgl_awal;
			if(!UFunc.isDateValid(vTanggal)) {
				vElfocus && vElfocus.focus();
				showToast("Periode Tanggal AWAL Laporan Tidak Valid !"); return
			}
			const vTanggalawalDT	= UFunc.toDate(uFormdataObj.tgl_awal);
			if(UFunc.DateIsBeyond(vTanggalawalDT)) {
				vElfocus && vElfocus.focus();
				showToast("Tanggal Awal Laporan Melewati Tanggal SAAT INI ! "); return
			}

			vElfocus	= document.getElementById("inptglakhir");
			vTanggal  	= uFormdataObj.tgl_akhir;
			if(!UFunc.isDateValid(vTanggal)) {
				vElfocus && vElfocus.focus();
				showToast("Periode Tanggal AKHIR Laporan Tidak Valid !"); return
			}
			const vTanggalnowDT 	= new Date();
			const vTanggalakhirDT	= UFunc.toDate(uFormdataObj.tgl_akhir);
			const vTanggalBatasDT	= new Date(vTanggalnowDT.getFullYear(),vTanggalnowDT.getMonth()+1,0);

			//alert(UFunc.SelisihHari(UFunc.DbDate(vTanggalBatasDT),UFunc.DbDate(vTanggalakhirDT))); return;
			if(UFunc.SelisihHari(UFunc.DbDate(vTanggalBatasDT),UFunc.DbDate(vTanggalakhirDT)) > 0) {
				vElfocus && vElfocus.focus();
				showToast("Tanggal Akhir Laporan Melewati Tanggal BULAN INI ! "); return
			}

			if(UFunc.SelisihHari(UFunc.DbDate(vTanggalawalDT),UFunc.DbDate(vTanggalakhirDT)) > uSelisihrangetanggal) {
				vElfocus && vElfocus.focus();
				showToast("Maksimal Selisih Range Tanggal adalah "+uSelisihrangetanggal+" hari.."+
					"<br/>Mohon Diperbaiki !"+
					""); return
			}
		}
		//alert(vTanggalDT);return;
		//--END VALIDASI_FILTER--/

		setDataloaded(false);
		apiLoaddata();
	}
	const hdlKlikSort = (_NAMAKOL) => {
		_NAMAKOL		= (_NAMAKOL||"").toUpperCase();
		const vNamenow	= (uSortedObj.nama||"").toUpperCase();
		const vSortnow	= (uSortedObj.jenis||"").toUpperCase();

		const vSortedObj		= uSortedObj;
		vSortedObj.init_aktif 	= "YA";
		if(vNamenow==="" || vNamenow !== _NAMAKOL) {
			vSortedObj.nama 	= _NAMAKOL.toLowerCase();
			vSortedObj.jenis 	= "ASCENDING";
		} else if(vNamenow===_NAMAKOL) {
			if(vSortnow==="ASCENDING")
				vSortedObj.jenis = "DESCENDING";
			else if(vSortnow==="DESCENDING") {
				 vSortedObj.nama 	= "";
				 vSortedObj.jenis 	= "";
			}
		}
		vSortedObj.init_aktif 	= undefined;

		setSortedObj(vSortedObj);
		setEfekview(!uEfekview);
	}
	const hdlKlikCetak = () => {
		if(uDatamainArr.length <= 0) return;

		const vContent 	= contentCetak();
		if(vContent === "") return
		//console.log("(Lapterapi - hdlKlikCetak) vContent = "+vContent)

		var pri 		= uFrameExport.contentWindow;
		pri.document.open();
		pri.document.write(vContent);
		pri.document.close();
		pri.window.focus();
		pri.window.print();
	}
	const hdlKlikExcel = () => {
		if(uDatamainArr.length <= 0) return;

		if(uFilterObj.jenis === "TAHUN") {
			excelTahunall(); return 
		}
		if(uFilterObj.jenis === "TANGGAL") {
			excelTanggalall(); return
		}
		if(uFilterObj.jenis === "BULAN") {
			if(parseInt(uFilterObj.terapimain_id||"0") > 0) {
				excelBulanterapi(); return
			}

			excelBulanall(); return
		}
	}
	//--END HANDEL--/

	//--INIT--/
	const initResettampilan = () => {
		setCaptionObj({}); setDatamainArr([]);// setJmlData(0);
		setFilterObj({}); setSortedObj({});
	}
	const initJmldata = () => {
		uElJmlData 
			&& (uElJmlData.innerHTML = UFunc.formatAngka(uJmlData));
	}
	const excelTanggalall = () => {
		const vCabangIdx	= UFunc.getObjectIndeks(uDatacabangArr,uFilterObj.cabang_id);
		const vCabangtext	= vCabangIdx>=0 ? uDatacabangArr[vCabangIdx].cabang_nama : "UNDF";
		
		const vTerapitext	= (parseInt(uFilterObj.terapimain_id)||0) <= 0 ? "SEMUA TERAPI" : uCaptionObj.title_sub;

		const vTgl		= parseInt((uFilterObj||{}).tgl)||0;
		const vBulanID	= parseInt((uFilterObj||{}).bln)||0;
		const vTahun	= parseInt((uFilterObj||{}).thn)||0;
		const vTanggalawalDT = UFunc.toDate(uFilterObj.tgl_awal);
		const vTanggalakhirDT= UFunc.toDate(uFilterObj.tgl_akhir);

		const vColspan		= 5;

		let vDatasetsArr 	= [];
		let vRowcount		= 0;
		let vColposwidth	= 50;

		let vTmpObj	= {
			no : "",
			tgl_periksa : "",
			terapi_caption : "",
			pasien_caption : "",
			nilai_terapi : "",
		};
		vDatasetsArr.push(vTmpObj);

		vRowcount++;
		uDatamainArr.map((vItems,vKeys)=>{
			const {
				pasien_caption,terapi_caption,nilai_terapi,
				terapi_main,terapi_sub,tgl_periksa
			} = vItems;

			vRowcount++;
			vColposwidth = (pasien_caption||"").length > vColposwidth 
				? (pasien_caption||"").length : vColposwidth; 

			vTmpObj	= {
				no : {v:vKeys+1,t:"n"},
				tgl_periksa: { v:(tgl_periksa), t:"d",s:{alignment:{horizontal:"left"}}},
				terapi_caption: (terapi_caption||"Undf Terapi"),
				pasien_caption: (pasien_caption||"Undf Pasien"),
				nilai_terapi: { v:parseFloat(nilai_terapi), t:"n", s:{numFmt: "#,##0"} },
			}
			vDatasetsArr.push(vTmpObj);
		});

		//--SUM_NILAI--/
		vTmpObj	= {
			no : {v: "JUMLAH",t:"s",s:{alignment:{horizontal:"center"},font:{bold:true} }},
			tgl_periksa: "",
			terapi_caption: "",
			pasien_caption: "",
			nilai_terapi: { v:parseFloat(uDatasumArr.nilai_terapi)||0, t:"n", s:{numFmt: "#,##0",font:{bold:true} } },
		};
		vDatasetsArr.push(vTmpObj);
		vRowcount++;
		//--END SUM_NILAI--/

		const wsrows	= [{hpt:43}]
		const wscols	= [
			{wpx:40},
			{wpx:90},
			{wpx:350},
			{wch:vColposwidth},
			{wpx:150},
		];
		
		const wsmerge	= [
			{s:{r:0,c:0},e:{r:0,c:vColspan - 1}},
			{s:{r:vRowcount,c:0},e:{r:vRowcount,c:vColspan - 2}}
		]

		const vTanggalnowDT	= new Date();
		const vTglawallabel	= vTanggalawalDT.getFullYear()+
			UFunc.leadZero(vTanggalawalDT.getMonth()+1)+
			UFunc.leadZero(vTanggalawalDT.getDate())+
			"";
		const vNamafile 	= 
			vTanggalnowDT.getFullYear()+
			UFunc.leadZero(vTanggalnowDT.getMonth()+1)+
			UFunc.leadZero(vTanggalnowDT.getDate())+"_LAPTERAPI_"+vTglawallabel+
		"";
		const vSheetlabel 	= vTglawallabel;
		const ws 			= XLSX.utils.json_to_sheet(vDatasetsArr);

		//--CUSTOM_HEADER--/
		const vJudullaporan = uBahasaObj["menus_"+(uActiveroute||"").toLowerCase()]+
			"\r\nPeriode "+UFunc.TglAngka(uFilterObj.tgl_awal)+" - "+UFunc.TglAngka(uFilterObj.tgl_akhir)+
			(uDatacabangArr.length > 1 ? "\r\nCabang: "+vCabangtext : "" )+
			((parseInt(uFilterObj.terapimain_id)||0) > 0 ? "\r\nTerai: "+vTerapitext : "")+
		"";
		const vHeaderArr = [
			{v:"No",s:{alignment:{horizontal:"center"},font:{bold:true}}}, 
			{v:"Tgl Periksa",s:{alignment:{horizontal:"left"},font:{bold:true}}}, 
			{v:"Terapi",s:{alignment:{horizontal:"left"},font:{bold:true}}}, 
			{v:"Nama Pasien",s:{alignment:{horizontal:"left"},font:{bold:true}}}, 
			{v:"Nilai (Rp)",s:{alignment:{horizontal:"center"},font:{bold:true}}}, 
		];

		XLSX.utils.sheet_add_aoa(ws, [[{v:vJudullaporan,t:"s",s:{
			alignment:{horizontal:"center",vertical:"center",wrapText: true},
			font:{bold:true} 
		}}]], { origin: "A1" });
		XLSX.utils.sheet_add_aoa(ws, [vHeaderArr], { origin: "A2" });
		//--END CUSTOM_HEADER--*/

		ws['!rows'] 	= wsrows;
		ws['!cols'] 	= wscols;
		ws["!merges"] 	= wsmerge;

		const wb 		= { Sheets: { [vSheetlabel]: ws }, SheetNames: [vSheetlabel] };
		const excelBuffer = XLSX.write(wb, { bookType: "xlsx", bookSST: true, type: "array" });
		const data 		= new Blob([excelBuffer], { type: fileType });
		FileSaver.saveAs(data, vNamafile + fileExtension);
	}
	const excelBulanall = () => {//--TIDAK_DIPAKAI--/
		const vCabangIdx	= UFunc.getObjectIndeks(uDatacabangArr,uFilterObj.cabang_id);
		const vCabangtext	= vCabangIdx>=0 ? uDatacabangArr[vCabangIdx].cabang_nama : "UNDF";
		
		const vTerapitext	= "SEMUA TERAPI";

		const vBulanID		= parseInt((uFilterObj||{}).bln)||0;
		const vTahun		= parseInt((uFilterObj||{}).thn)||0;

		const vColspan		= 3;

		let vDatasetsArr 	= [];
		let vRowcount		= 0;
		let vColposwidth	= 50;

		let vTmpObj	= {
			no : "",
			terapi_caption : "",
			nilai_terapi : "",
		};
		vDatasetsArr.push(vTmpObj);

		vRowcount++;
		uDatamainArr.map((vItems,vKeys)=>{
			const {
				terapi_caption,terapi_main,nilai_terapi
			} = vItems;

			vRowcount++;
			vColposwidth = (terapi_caption||"").length > vColposwidth 
				? (terapi_caption||"").length : vColposwidth; 

			vTmpObj	= {
				no : {v:vKeys+1,t:"n"},
				terapi_caption: (terapi_caption||"Undf Terapi"),
				nilai_terapi: { v:parseFloat(nilai_terapi), t:"n", s:{numFmt: "#,##0"} },
			}
			vDatasetsArr.push(vTmpObj);
		});

		//--SUM_NILAI--/
		vTmpObj	= {
			no : {v: "JUMLAH",t:"s",s:{alignment:{horizontal:"center"},font:{bold:true} }},
			terapi_caption: "",
			nilai_terapi: { v:parseFloat(uDatasumArr.nilai_terapi)||0, t:"n", s:{numFmt: "#,##0",font:{bold:true} } },
		};
		vDatasetsArr.push(vTmpObj);
		vRowcount++;
		//--END SUM_NILAI--/

		const wsrows	= [{hpt:43}]
		const wscols	= [
			{wpx:40},
			{wch:vColposwidth},
			{wpx:150},
		];
		
		const wsmerge	= [
			{s:{r:0,c:0},e:{r:0,c:vColspan - 1}},
			{s:{r:vRowcount,c:0},e:{r:vRowcount,c:vColspan - 2}}
		]

		const vTanggalnowDT	= new Date()
		const vNamafile 	= 
			vTanggalnowDT.getFullYear()+
			UFunc.leadZero(vTanggalnowDT.getMonth()+1)+
			UFunc.leadZero(vTanggalnowDT.getDate())+"_LAPTERAPI_"+
			(cBulanPendek[vBulanID-1]).toUpperCase()+vTahun+
		"";
		const vSheetlabel 	= (cBulanPendek[vBulanID-1])+vTahun;
		const ws 			= XLSX.utils.json_to_sheet(vDatasetsArr);

		//--CUSTOM_HEADER--/
		const vJudullaporan = uBahasaObj["menus_"+(uActiveroute||"").toLowerCase()]+
			"\r\nPeriode Bulan "+(cBulanPendek[vBulanID-1]).toUpperCase()+" "+vTahun+
			(uDatacabangArr.length > 1 ? "\r\nCabang: "+vCabangtext : "" )+
		"";
		const vHeaderArr = [
			{v:"No",s:{alignment:{horizontal:"center"},font:{bold:true}}}, 
			{v:"Terapi",s:{alignment:{horizontal:"left"},font:{bold:true}}}, 
			{v:"Nilai (Rp)",s:{alignment:{horizontal:"center"},font:{bold:true}}}, 
		];

		XLSX.utils.sheet_add_aoa(ws, [[{v:vJudullaporan,t:"s",s:{
			alignment:{horizontal:"center",vertical:"center",wrapText: true},
			font:{bold:true} 
		}}]], { origin: "A1" });
		XLSX.utils.sheet_add_aoa(ws, [vHeaderArr], { origin: "A2" });
		//--END CUSTOM_HEADER--*/

		ws['!rows'] 	= wsrows;
		ws['!cols'] 	= wscols;
		ws["!merges"] 	= wsmerge;

		const wb 		= { Sheets: { [vSheetlabel]: ws }, SheetNames: [vSheetlabel] };
		const excelBuffer = XLSX.write(wb, { bookType: "xlsx", bookSST: true, type: "array" });
		const data 		= new Blob([excelBuffer], { type: fileType });
		FileSaver.saveAs(data, vNamafile + fileExtension);
	}
	const excelBulanterapi = () => {//--TIDAK_DIPAKAI--/
		const vCabangIdx	= UFunc.getObjectIndeks(uDatacabangArr,uFilterObj.cabang_id);
		const vCabangtext	= vCabangIdx>=0 ? uDatacabangArr[vCabangIdx].cabang_nama : "UNDF";
		
		const vTerapiIdx	= UFunc.getObjectIndeks(uTerapimainArr,uFilterObj.terapimain_id);
		const vTerapitext	= uTerapimainArr[vTerapiIdx].nama_terapi;

		const vBulanID		= parseInt((uFilterObj||{}).bln)||0;
		const vTahun		= parseInt((uFilterObj||{}).thn)||0;

		const vColspan		= 5;

		let vDatasetsArr 	= [];
		let vRowcount		= 0;
		let vColposwidth	= 50;

		let vTmpObj	= {
			no : "",
			tanggal : "",
			terapi_caption : "",
			pasien_caption : "",
			nilai_terapi : "",
		};
		vDatasetsArr.push(vTmpObj);

		vRowcount++;
		uDatamainArr.map((vItems,vKeys)=>{
			const {
				tanggal,pasien_caption,terapi_caption,nilai_terapi
			} = vItems;

			vRowcount++;
			vColposwidth = (pasien_caption||"").length > vColposwidth 
				? (pasien_caption||"").length : vColposwidth; 

			vTmpObj	= {
				no : {v:vKeys+1,t:"n"},
				tanggal: { v:tanggal, t:"d",s:{alignment:{horizontal:"left"},}},
				terapi_caption: (terapi_caption||"Undf Terapi"),
				pasien_caption: (pasien_caption||"Undf Pasien"),
				nilai_terapi: { v:parseFloat(nilai_terapi), t:"n", s:{numFmt: "#,##0"} },
			}
			vDatasetsArr.push(vTmpObj);
		});

		//--SUM_NILAI--/
		vTmpObj	= {
			no : {v: "JUMLAH",t:"s",s:{alignment:{horizontal:"center"},font:{bold:true} }},
			tanggal: "",
			terapi_caption: "",
			pasien_caption: "",
			nilai_terapi: { v:parseFloat(uDatasumArr.nilai_terapi)||0, t:"n", s:{numFmt: "#,##0",font:{bold:true} } },
		};
		vDatasetsArr.push(vTmpObj);
		vRowcount++;
		//--END SUM_NILAI--/

		const wsrows	= [{hpt:51}]
		const wscols	= [
			{wpx:40},
			{wpx:100},
			{wpx:250},
			{wch:vColposwidth},
			{wpx:150},
		];
		
		const wsmerge	= [
			{s:{r:0,c:0},e:{r:0,c:vColspan - 1}},
			{s:{r:vRowcount,c:0},e:{r:vRowcount,c:vColspan - 2}}
		]

		const vTanggalnowDT	= new Date()
		const vNamafile 	= 
			vTanggalnowDT.getFullYear()+
			UFunc.leadZero(vTanggalnowDT.getMonth()+1)+
			UFunc.leadZero(vTanggalnowDT.getDate())+"_LAPTERAPI_"+
			(cBulanPendek[vBulanID-1]).toUpperCase()+vTahun+
		"";
		const vSheetlabel 	= (cBulanPendek[vBulanID-1])+vTahun;
		const ws 			= XLSX.utils.json_to_sheet(vDatasetsArr);

		//--CUSTOM_HEADER--/
		const vJudullaporan = uBahasaObj["menus_"+(uActiveroute||"").toLowerCase()]+
			"\r\nPeriode Bulan "+(cBulanPendek[vBulanID-1]).toUpperCase()+" "+vTahun+
			(uDatacabangArr.length > 1 ? "\r\nCabang: "+vCabangtext : "" )+
			"\r\n"+(vTerapitext||"").toUpperCase()+
		"";
		const vHeaderArr = [
			{v:"No",s:{alignment:{horizontal:"center"},font:{bold:true}}}, 
			{v:"Tanggal",s:{alignment:{horizontal:"left"},font:{bold:true}}}, 
			{v:"Terapi",s:{alignment:{horizontal:"left"},font:{bold:true}}}, 
			{v:"Nama Pasien",s:{alignment:{horizontal:"left"},font:{bold:true}}}, 
			{v:"Nilai (Rp)",s:{alignment:{horizontal:"center"},font:{bold:true}}}, 
		];

		XLSX.utils.sheet_add_aoa(ws, [[{v:vJudullaporan,t:"s",s:{
			alignment:{horizontal:"center",vertical:"center",wrapText: true},
			font:{bold:true} 
		}}]], { origin: "A1" });
		XLSX.utils.sheet_add_aoa(ws, [vHeaderArr], { origin: "A2" });
		//--END CUSTOM_HEADER--*/

		ws['!rows'] 	= wsrows;
		ws['!cols'] 	= wscols;
		ws["!merges"] 	= wsmerge;

		const wb 		= { Sheets: { [vSheetlabel]: ws }, SheetNames: [vSheetlabel] };
		const excelBuffer = XLSX.write(wb, { bookType: "xlsx", bookSST: true, type: "array" });
		const data 		= new Blob([excelBuffer], { type: fileType });
		FileSaver.saveAs(data, vNamafile + fileExtension);
	}
	const excelTahunall = () => {//--TIDAK_DIPAKAI--/
		const vCabangIdx	= UFunc.getObjectIndeks(uDatacabangArr,uFilterObj.cabang_id);
		const vCabangtext	= vCabangIdx>=0 ? uDatacabangArr[vCabangIdx].cabang_nama : "UNDF";
		const vTerapitext	= "SEMUA TERAPI";

		const vTahun		= parseInt((uFilterObj||{}).thn)||0;

		let vColspan		= 3;
		let vDatasetsArr 	= [];
		let vRowcount		= 0;
		let vColposwidth	= 50;

		let vTmpObj	= {
			no : "",
			terapi_caption : "",
		};
		cBulanPendek.map(vItembulan => {
			vTmpObj[vItembulan.toLowerCase()] = "";
			vColspan++;
		});
		vTmpObj.total = "";
		vDatasetsArr.push(vTmpObj);
		vRowcount++;
		console.log("vTmpObj HEADER => "+JSON.stringify(vTmpObj));

		uDatamainArr.map((vItems,vKeys)=>{
			const {
				terapi_caption,id
			} = vItems;

			vColposwidth = (terapi_caption||"").length > vColposwidth 
				? (terapi_caption||"").length : vColposwidth; 

			vTmpObj	= {
				no : {v:vKeys+1,t:"n"},
				terapi_caption: (terapi_caption||"Undf Terapi"),
			}
			cBulanPendek.map((vItembulan,vKeybulan) => {
				vTmpObj[vItembulan.toLowerCase()] = { v:parseFloat(vItems["nilai_"+UFunc.leadZero(vKeybulan)]), t:"n", s:{numFmt: "#,##0"} };
			});
			vTmpObj.total =
				{ v:parseFloat(vItems["nilai_total"]), t:"n", s:{numFmt: "#,##0"} };
			vDatasetsArr.push(vTmpObj);
			vRowcount++;

			console.log("vTmpObj "+vKeys+" => "+JSON.stringify(vTmpObj));
			console.log("vItems "+vKeys+" => "+JSON.stringify(vItems));
		});

		//--SUM_NILAI--/
		const vNolArr		= [0,0,0,0,0,0,0,0,0,0,0,0,0];
		const vTotalArr		= uDatasumArr.nilai_arr || vNolArr;
		vTmpObj	= {
			no : {v: "JUMLAH",t:"s",s:{alignment:{horizontal:"center"},font:{bold:true} }},
			terapi_caption: "",
		};
		cBulanPendek.map((vItembulan,vKeybulan) => {
			vTmpObj[(vItembulan).toLowerCase()] =
				{ v:parseFloat(vTotalArr[vKeybulan]), t:"n", s:{numFmt: "#,##0",font:{bold:true}} };
		});
		vTmpObj.total = 
			{ v:parseFloat(vTotalArr[vTotalArr.length-1]), t:"n", s:{numFmt: "#,##0",font:{bold:true}} };
		vDatasetsArr.push(vTmpObj);
		vRowcount++;
		//--END SUM_NILAI--/

		const wsrows	= [{hpt:51}]
		const wscols	= [
			{wpx:40},
			{wch:vColposwidth},
		];
		cBulanPendek.map(vItembulan => {
			wscols.push({wpx:110});
		});
		wscols.push({wpx:150});

		const wsmerge	= [
			{s:{r:0,c:0},e:{r:0,c:vColspan - 1}},
			{s:{r:vRowcount,c:0},e:{r:vRowcount,c:vColspan - 14}}
		]

		const vTanggalnowDT	= new Date()
		const vNamafile 	= 
			vTanggalnowDT.getFullYear()+
			UFunc.leadZero(vTanggalnowDT.getMonth()+1)+
			UFunc.leadZero(vTanggalnowDT.getDate())+"_LAPTERAPI_"+
			vTahun+
		"";
		const vSheetlabel 	= vTahun.toString();
		const ws 			= XLSX.utils.json_to_sheet(vDatasetsArr);

		//--CUSTOM_HEADER--/
		const vJudullaporan = uBahasaObj["menus_"+(uActiveroute||"").toLowerCase()]+
			"\r\nPeriode Tahun "+vTahun+
			(uDatacabangArr.length > 1 ? "\r\nCabang: "+vCabangtext : "" )+
		"";
		const vHeaderArr = [
			{v:"No",s:{alignment:{horizontal:"center"},font:{bold:true}}}, 
			{v:"Terapi",s:{alignment:{horizontal:"left"},font:{bold:true}}}, 
		];
		cBulanPendek.map(vItembulan => {
			vHeaderArr.push({v:vItembulan.toUpperCase(),s:{alignment:{horizontal:"center"},font:{bold:true}}});
		});
		vHeaderArr.push({v:"Total",s:{alignment:{horizontal:"center"},font:{bold:true}}});

		XLSX.utils.sheet_add_aoa(ws, [[{v:vJudullaporan,t:"s",s:{
			alignment:{horizontal:"center",vertical:"center",wrapText: true},
			font:{bold:true} 
		}}]], { origin: "A1" });
		XLSX.utils.sheet_add_aoa(ws, [vHeaderArr], { origin: "A2" });
		//--END CUSTOM_HEADER--*/

		ws['!rows'] 	= wsrows;
		ws['!cols'] 	= wscols;
		ws["!merges"] 	= wsmerge;

		const wb 		= { Sheets: { [vSheetlabel]: ws }, SheetNames: [vSheetlabel] };
		const excelBuffer = XLSX.write(wb, { bookType: "xlsx", bookSST: true, type: "array" });
		const data 		= new Blob([excelBuffer], { type: fileType });
		FileSaver.saveAs(data, vNamafile + fileExtension);
	}
	//--END INIT--/

	//--CONTENT--/
	const contentDlgform = () => {
		if(!uIsDlgformshow) return (<></>)//>

		const vJmlTahunlaporan	= parseInt(uSystemsettingObj.jml_tahun_laporan)||5;
		const vCabangviewArr	= uTokenObj.userhak==="FREEROLE" ? uDatacabangArr
			: uDatacabangArr.filter(vItems=>(uTokenObj.user_cabangarr || []).includes(vItems.id.toString()))
		const vTahunnow			= (new Date()).getFullYear();
		const vTerapiviewArr	= uTerapimainArr;

		return (
		<CForm>
		{uDatacabangArr.length > 1 && (
		<CRow className="my-2">
		<CCol xs="3" md="4">Cabang</CCol>
		<CCol className="text-end">
		<CFormSelect size="sm"
			value={uFormdataObj.cabang_id||0}
			onChange={(e)=>setFormdataObj({...uFormdataObj,cabang_id:e.target.value})}
			id="inpcabangid">
			{vCabangviewArr.map((vItems,vKeys)=>{
				const {
					id,cabang_nama
				} = vItems

				return (
				<option value={id} key={vKeys}>{(cabang_nama||"UNDF").toUpperCase()}</option>
				)
			})}
			</CFormSelect>
		</CCol>
		</CRow>
		)}

		<CRow className="my-2 d-none">
		<CCol xs="3" md="4">Jenis Periode</CCol>
		<CCol className="text-end">
		<CFormSelect size="sm"
			value={uFormdataObj.jenis}
			onChange={(e)=>setFormdataObj({...uFormdataObj,jenis:e.target.value})}
			id="inpjenis">
			<option value="TANGGAL">per RANGE TANGGAL</option>
			<option value="TAHUN">per TAHUN</option>
			</CFormSelect>
		</CCol>
		</CRow>

		{(uFormdataObj.jenis||"TANGGAL")==="TANGGAL" ? (
		<CRow className="my-2">
		<CCol xs="3" md="4">{uBahasaObj.word_tanggal||"Tanggal"}</CCol>
		<CCol className="text-end">
			<CInputGroup size="sm">
			<CFormInput size="sm" type="date"
				value={uFormdataObj.tgl_awal}
				onChange={(e)=>setFormdataObj({...uFormdataObj,tgl_awal:e.target.value})}
				id="inptglawal"/>
			<CInputGroupText>s.d.</CInputGroupText>
			<CFormInput size="sm" type="date"
				value={uFormdataObj.tgl_akhir}
				onChange={(e)=>setFormdataObj({...uFormdataObj,tgl_akhir:e.target.value})}
				id="inptglakhir"/>
			</CInputGroup>
		</CCol>
		</CRow>
		) : (
		<CRow className="my-2">
		<CCol xs="3" md="4">Tahun</CCol>
		<CCol xs="8" lg="4" className="text-end">
			<CInputGroup size="sm">
			<CFormSelect size="sm"
				value={uFormdataObj.thn}
				onChange={(e)=>setFormdataObj({...uFormdataObj,thn:e.target.value})}
				id="inptahun">
				{[...new Array(vJmlTahunlaporan)].map((vItems,vKeys)=>{
					return (
					<option value={(vTahunnow - vKeys)} key={vKeys}>{(vTahunnow - vKeys)}</option>
					)
				})}
			</CFormSelect>
			</CInputGroup>
		</CCol>
		<CCol md="3"/>
		</CRow>
		)}

		<CRow className={"my-2"}>
		<CCol xs="3" md="4">Terapi</CCol>
		<CCol className="text-end">
		<CFormSelect size="sm"
			value={uFormdataObj.terapimain_id}
			onChange={(e)=>setFormdataObj({...uFormdataObj,terapimain_id:e.target.value})}
			onKeyDown={(e)=>UFunc.hdlKeyDownInput(e, "btnDialogSimpan")}
			id="inpterapimainid">
			<option value="0">-- SEMUA TERAPI --</option>
			{(uFormdataObj.jenis==="BULAN" || uFormdataObj.jenis==="TANGGAL") && (
			<>
			{vTerapiviewArr.map((vItems,vKeys)=>{
				const { id,nama_terapi } = vItems

				return (
				<option value={id} key={vKeys} className="text-capitalize">{(nama_terapi||"UNDF")}</option>
				)
			})}
			</>
			)}
			</CFormSelect>
		</CCol>
		</CRow>
		</CForm>
		)//>
	}
	const contentLaporan = () => {
		if(!uIsDataloaded) return ""

		if(uJmlData <= 0) return (
			<div className="mx-md-5 px-lg-5">
			&middot;&middot; {uBahasaObj.caption_dataempty||"Data Tidak Ada"} &middot;&middot;
			</div>
		)//>

		if(uFilterObj.jenis === "TAHUN") {
			return contentTahunall();
		}
		if(uFilterObj.jenis === "TANGGAL") {
			return contentTanggalall();
		}

		return (<></>)//>
	}
	const contentTanggalall = () => {
		if(uFilterObj.jenis !== "TANGGAL") return ""
		//if(parseInt(uFilterObj.terapimain_id||"") > 0) return (<></>)

		const vMin			= (uPageActive-1)*uMaxData;
		const vMax			= (vMin+uMaxData);
		let vNumber			= (vMin);

		const vStylekolfixed = {
			position: "sticky",
			left: 0,
			background: "#f0f0f0",
			zIndex: 1,
			borderRight:"1px solid #DCDCDC",
		}
		const vWidthtabel = 900;

		const vDatamainArr	= uDatamainArr.slice(vMin,(vMax));

		return (
		<div style={{overflowX:"auto"}}
			className=""
			id="iddivtabel">
		<table 
			style={{minWidth:vWidthtabel,width:"100%"}}
			className="table table-borderless table-striped table-hover" id="idtabeldata">
		<thead>
			<tr className="text-center align-top classfontsmaller">
			<th width={40} className="px-1 border" style={vStylekolfixed}>No</th>

			<th className="px-1 text-start border" style={{...vStylekolfixed,left:40,minWidth:150,width:"15%"}}>{uBahasaObj.word_tanggal||"Tanggal"}</th>
			<th className="px-1 text-start border">{uBahasaObj.word_terapi||"Terapi"}</th>
			<th width="30%" className="px-1 text-start border">{uBahasaObj.word_pasien||"Pasien"}</th>
			<th width={150} className="px-1 border">
				<span className={"me-1"+((uSortedObj.nama||"")==="nilai_terapi" ? " text-danger" : "")}>
				{uBahasaObj.word_nilai||"Nilai"} (Rp)
				</span>
				<CLink className={"classcursorpointer text-black"}
					onClick={()=>hdlKlikSort("nilai_terapi")}>
				<CIcon icon={((uSortedObj.nama||"")==="nilai_terapi" && (uSortedObj.jenis||"")==="DESCENDING" ? "cilArrowBottom" : "cilArrowTop")}
					className="align-middle" height={20}/>
				</CLink>
			</th>
			</tr>
		</thead>

		<tbody>
		{vDatamainArr.map((vItems,vKeys)=>{
			const {
				tgl_periksa,
				terapi_main,terapi_sub,pasien_caption,nilai_terapi,
			} = vItems;

			vNumber++;
			return (
			<tr key={vKeys} className="align-top text-end">
			<td className="px-1" style={vStylekolfixed}>{vNumber}.</td>
			
			<td className="px-1 text-start" style={{...vStylekolfixed,left:40}}>
				{UFunc.TglAngka(tgl_periksa)}
			</td>
			<td className="px-1 text-start">
				<b>{(terapi_main||"UNDF")}</b>
				{" "}
				<i>{(terapi_sub)}</i>
			</td>
			<td className="px-1 text-start text-primary">{(pasien_caption||"UNDF")}</td>
			<td className="px-1">
				<span className={parseFloat(nilai_terapi||"0")>=0 ? "":"text-danger"}>
				<span className={parseFloat(nilai_terapi||"0")>=0 ? "d-none":""}>(</span>
					{UFunc.formatAngka(nilai_terapi)}
				<span className={parseFloat(nilai_terapi||"0")>=0 ? "d-none":""}>)</span>
				</span>
			</td>
			</tr>
			);
		})}
		</tbody>

		<tfoot>
		<tr className="fw-bolder bg-primary text-white align-top text-end">
			<td colSpan={2} className="px-1 bg-primary d-lg-none text-center text-uppercase" style={vStylekolfixed}>{uBahasaObj.word_jumlah||"JUMLAH"}</td>
			<td colSpan={2} className="px-1 d-lg-none"/>
			<td colSpan={4} className="px-1 bg-primary d-none d-lg-table-cell text-center text-uppercase" style={vStylekolfixed}>{uBahasaObj.word_jumlah||"JUMLAH"}</td>
			<td className="px-1">
				<span className={parseFloat(uDatasumArr.nilai_terapi||"0")>=0 ? "d-none":""}>(</span>
				{UFunc.formatAngka(Math.abs(uDatasumArr.nilai_terapi))}
				<span className={parseFloat(uDatasumArr.nilai_terapi||"0")>=0 ? "d-none":""}>)</span>
			</td>
		</tr>
		</tfoot>
		</table>
		</div>
		)//>
	}
	const contentTahunall = () => {//--TIDAK_DIPAKAI--/
		if(uFilterObj.jenis !== "TAHUN") return ""
		if(parseInt(uFilterObj.terapimain_id||"0") > 0) return ""

		const vMin			= (uPageActive-1)*uMaxData;
		const vMax			= (vMin+uMaxData);
		let vNumber			= (vMin);

		const vDatamainArr	= uDatamainArr.slice(vMin,(vMax));

		const vKolwidth		= Math.round(83/13);
		const vNolArr		= [0,0,0,0,0,0,0,0,0,0,0,0,0];
		const vTotalArr		= uDatasumArr.nilai_arr || vNolArr;

		const vWidthno		= 35;
		const vWidthFirstkol= 200;
		const vWidthkolnilai= 100;

		const vWidthtabel	= vWidthno+vWidthFirstkol+(vWidthkolnilai*13)

		const vStylekolfixed = {
			position: "sticky",
			left: 0,
			background: "#f0f0f0",
			zIndex: 1,
			borderRight:"1px solid #DCDCDC",
		}

		return (
		<div style={{overflowX:"auto"}} id="iddivtabel">
		<table
			style={{minWidth:vWidthtabel,width:"100%"}}
			className="table table-borderless table-striped table-hover"
			id="idtabeldata">
		<thead>
			<tr className="align-top text-center classfontsmaller">
			<th width={vWidthno} style={vStylekolfixed} className="px-1 border">No</th>
			<th width={vWidthFirstkol} style={{...vStylekolfixed,left:vWidthno}} className="px-1 text-start border">{uBahasaObj.word_terapi||"Terapi"}</th>
			{cBulanPendek.map((vItems,vKeys)=>{
				return (<th width={vWidthkolnilai} key={vKeys} className="px-1 border">{vItems}</th>)
			})}
			<th width={vWidthkolnilai} className="px-1 border">
				<span className={"me-1"+((uSortedObj.nama||"")==="nilai_total" ? " text-danger" : "")}>
				{uBahasaObj.word_total||"Total"}
				</span>
				<CLink className={"classcursorpointer text-black"}
					onClick={()=>hdlKlikSort("nilai_total")}>
				<CIcon icon={((uSortedObj.nama||"")==="nilai_total" && (uSortedObj.jenis||"")==="DESCENDING" ? "cilArrowBottom" : "cilArrowTop")}
					className="align-middle" height={20}/>
				</CLink>
			</th>
			</tr>
		</thead>
		<tbody>
		{vDatamainArr.map((vItems,vKeys)=>{
			const {
				terapi_caption,id
			} = vItems;

			vNumber++;

			return (
			<tr id={"idtr"+vKeys} className="align-top text-end" key={vKeys}>
			<td style={vStylekolfixed} className="px-1">
				<small>{vNumber}.</small>
			</td>
			<td style={{...vStylekolfixed,left:vWidthno}} 
				className="px-1 text-start">
				<small>{terapi_caption||"UNDF"}</small>
			</td>
			{cBulanPendek.map((vItemnilai,vKeynilai)=>{
				return (
				<td className="px-1" key={vKeynilai}>
				<small>{UFunc.formatAngka(vItems["nilai_"+UFunc.leadZero(vKeynilai)])}</small>
				</td>
				)
			})}
			<td className="px-1 text-primary">
				<small>{UFunc.formatAngka(vItems["nilai_total"])}</small>
			</td>
			</tr>
			)
		})}
		</tbody>

		<tfoot>
		<tr className="fw-bolder bg-primary text-white bg-primary text-end">
		<td colSpan={2} className="px-1 text-center bg-primary" style={vStylekolfixed}>JUMLAH</td>
		{vTotalArr.map((vItems,vKeys)=>{
			return (<td className="px-1" key={vKeys}>{UFunc.formatAngka(vItems)}</td>)
		})}
		</tr>
		</tfoot>
		</table>
		</div>
		)//>
	}
	const contentCetak = () => {
		if(uDatamainArr.length <= 0) return "";

		if(uFilterObj.jenis==="TANGGAL") {
			return cetakTanggalall();
		}
	}
	const cetakTanggalall = () => {
		const vCabangIdx	= UFunc.getObjectIndeks(uDatacabangArr,uFilterObj.cabang_id);
		const vCabangtext	= vCabangIdx>=0 ? uDatacabangArr[vCabangIdx].cabang_nama : "UNDF";
		
		const vTerapitext	= uFilterObj.terapimain_id <= 0 ? "SEMUA TERAPI" : uCaptionObj.title_sub;

		let vHTMLs 	= uHTMLstylelaporan;
		vHTMLs += `
			<table id="idtabelhtml">
			<thead>
			<tr>
			<td colspan="6">
			<div><b>`+(uBahasaObj["menus_"+uActiveroute.toLowerCase()]||"Laporan").toUpperCase()+`</b></div>
			<div>`+uCaptionObj.title+`</div>`+
			(uDatacabangArr.length > 1 ? `<div>Cabang: `+vCabangtext+` - `+vTerapitext+`</div>`
				: `<div>`+vTerapitext+`</div>`)+
			`</td>
			</tr>
			<tr class="idtabelheader">
				<th width="5%">No</th>
				<th align="left" width="13%">`+(uBahasaObj.word_tanggal||"Tanggal")+`</th>
				<th align="left">`+(uBahasaObj.word_terapi||"Terapi")+`</th>
				<th align="left" width="30%">`+(uBahasaObj.word_pasien||"Pasien")+`</th>
				<th width="18%">`+(uBahasaObj.word_nilai||"Nilai")+` (Rp)</th>
			</tr>
			</thead>
			<tbody>`;
		vHTMLs += uDatamainArr.map((vItems,vKeys)=>{
			const {
				tgl_periksa,
				pasien_caption,terapi_caption,nilai_terapi,
				terapi_main,terapi_sub
			} = vItems;

			return (
			`<tr key={vKeys} valign="top">
				<td align="right" style="font-size:smaller">`+(vKeys+1)+`.</td>
				<td align="left">`+UFunc.TglAngka(tgl_periksa)+`</td>
				<td align="left">`+
					(terapi_main||"UNDF")+
					` <i>`+(terapi_sub||"UNDF")+`</i>`+
				`</td>
				<td align="left">`+(pasien_caption||"UNDF")+`</td>
				<td align="right">`+
				(parseFloat(nilai_terapi||"0") >= 0 ? UFunc.formatAngka(nilai_terapi)
					: "("+UFunc.formatAngka(Math.abs(nilai_terapi))+")"
					)+
				`</td>
			</tr>
			`);
		}).join("");
		vHTMLs += `
			</tbody>
			<tfoot>
			<tr>
			<td colspan="4" align="center">JUMLAH</td>
			<td align="right">`+
				(parseFloat(uDatasumArr.nilai_terapi) >= 0 
					? UFunc.formatAngka(uDatasumArr.nilai_terapi) 
					: "("+UFunc.formatAngka(Math.abs(uDatasumArr.nilai_terapi))+")")+
			`</td>
			</tr>
			</tfoot>
			</table>
		`;

		return vHTMLs;
	}
	//--END CONTENT--/

	//--REST_API--/
	const apiLoadawal = () => {
		setHtml500msg();
		setLoading(true);

		/*//--TESTING_FRONTEND--/
		console.log("(Lapterapi - apiLoadawal) LEWaT "); 
		let vTimeout = setTimeout(()=>{ clearTimeout(vTimeout); },2500); return
		//--END TESTING_FRONTEND--*/

		const vDATAS	= JSON.stringify({
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api2/api_lapterapi/ld_init";

		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200) {setSessionaktif(false); return response.json();} })
		.then((output_string) => {
			setSessionaktif(true);
			setLoading(false);
			if(output_string.tampil) {
				setTerapimainArr(JSON.parse(output_string.dataterapimain||"[]"));
			} else if(output_string.info) {
				setHtml500msg(output_string.info);
			} else if(output_string.errors) {
				console.log("(Lapterapi - apiLoadawal) output_string.errors : "+output_string.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				setHtml500msg("<font color='red'>"+vMsg+"</font>");
			} else if(output_string.expired) {
				setDlgformshow(false); setLoading(true); prosesExpired();
			}
		})
		.catch((error) =>{
			setLoading(false);
			console.log("(Lapterapi - apiLoadawal) catch-error : "+error);
			//showToast(pjson.mydefault.msg500str.join(" "),"ERROR");
			setHtml500msg(pjson.mydefault.msg500str.join(" "));
		});
	}
	const apiLoaddata = () => {
		uElBtnsimpan && (uElBtnsimpan.disabled = true)
		setLoading(true);
		const vTmpFilterObj 		= uFormdataObj;
		vTmpFilterObj.init_change 	= undefined;

		/*//--TESTING_FRONTEND--/
		let vTmpObj	= []
		let vTimeout = setTimeout(()=>{
		},2500); return
		//--END TESTING_FRONTEND--*/

		let vApiurl	=  "";
		if(vTmpFilterObj.jenis==="TAHUN") {
			vApiurl = "ld_tahunall";
		} else if(vTmpFilterObj.jenis==="BULAN") {
			vApiurl = "ld_bulanall";
			if(parseInt(vTmpFilterObj.terapimain_id) > 0)
				vApiurl = "ld_bulanterapi"
		} else {
			vApiurl = "ld_tanggalall";
		}
		const vDATAS	= JSON.stringify({
			send_filterlist : JSON.stringify(vTmpFilterObj),
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api2/api_lapterapi/"+vApiurl;

		setTimeelapse(0);
		const vTimeBegin = new Date();
		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200) {setSessionaktif(false); return response.json();} })
		.then((output_string) => {
			setSessionaktif(true);
			uElBtnsimpan && (uElBtnsimpan.disabled = false)
			setLoading(false);
			if(output_string.tampil) {
				setFilterObj(vTmpFilterObj);
				const vLoadArr	= JSON.parse(output_string.dataobject||"[]");
				/*//--LOAD_PER_PAGE--/
				vLoadArr.map(vItems=>vItems.pg = parseInt(_PAGE)||1);
				setDatamainArr([...vDatamainArr,...vLoadArr]);
				setJmlData(parseInt(output_string.totaldata||uJmlData));
				//--END LOAD_PER_PAGE--*/

				//--LOAD_ALL_VIEW_PER_PAGE--/
				//console.log("(Lapterapi - apiLoaddata) vLoadArr => "+JSON.stringify(vLoadArr));
				setDatamainArr(vLoadArr);
				//--END LOAD_ALL_VIEW_PER_PAGE--*/

				setFirstload("TIDAK");
				
				hdlToggleDlgform();
				setDataloaded(true);
				const vTimeEnd = new Date();
				const vTimeDiff = vTimeEnd - vTimeBegin; //in ms
				setTimeelapse(vTimeDiff);
			} else if(output_string.info) {
				showToast(output_string.info);
			} else if(output_string.errors) {
				console.log("(Lapterapi - apiLoaddata) output_string.errors : "+output_string.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				showToast(vMsg,"ERROR");
			} else if(output_string.expired) {
				setLoading(true); prosesExpired();
			}
		})
		.catch((error) =>{
			uElBtnsimpan && (uElBtnsimpan.disabled = false)
			setLoading(false);
			console.log("(Lapterapi - apiLoaddata) catch-error : "+error);
			showToast(pjson.mydefault.msg500str.join(" "),"ERROR");
		});
	}
	//--END REST_API--/

	React.useEffect(()=>{
		uDispatch({type: "set", effectApp: !uEfekapp});
		uDispatch({type: "set", gUrlbefore: window.location.pathname + window.location.search});
		
		apiLoadawal();

		return () => {
			setDlgformshow(false);
			setDatamainArr([]); setDataloaded(false); 
			setTerapimainArr([])
		}
	},[])
	React.useEffect(()=>{ initJmldata() },[uElJmlData])
	React.useEffect(()=>{
		let vJmlHal	= Math.ceil(uJmlData / uMaxData);
		setJmlHal(vJmlHal);//-*/
		setPageActive(uPageActive<=0?1:uPageActive);

		initJmldata()
	},[uJmlData])
	React.useEffect(()=>{
		if(uDatamainArr.length <= 0)
			{ setDatadefaultArr([]); return }
		setDatadefaultArr([{init_change:"1"},...uDatamainArr]) 
	},[uDatamainArr])
	React.useEffect(()=>{
		setJmlData(uDatamainArr.length)
		if(uDatamainArr.length <= 0)
			{ setDatasumObj({}); return }

		let vNetto		= 0;
		let vNilaiArr	= [0,0,0,0,0,0,0,0,0,0,0,0,0];
		if(uFilterObj.jenis === "BULAN"
			|| uFilterObj.jenis === "TANGGAL"
			) {
			vNetto	= uDatamainArr.reduce(
				(vStores,vItems) => vStores = vStores + parseFloat(vItems.nilai_terapi||"0"), 0);
		}
		if(uFilterObj.jenis === "TAHUN") {
			vNetto	= uDatamainArr.reduce(
				(vStores,vItems) => vStores = vStores + parseFloat(vItems.nilai_terapi||"0"), 0);

			if(parseFloat(uFilterObj.terapimain_id||"0") <= 0) {
				let vNilaitmpArr	= cBulanPendek.map((vItembulan,vKeybulan)=>{
					return (
						uDatamainArr.reduce(
						(vStores,vItems) => vStores = vStores + parseFloat(vItems["nilai_"+UFunc.leadZero(vKeybulan)]||"0"), 0)
					)
				});
				vNilaitmpArr.push(
					uDatamainArr.reduce(
						(vStores,vItems) => vStores = vStores + parseFloat(vItems["nilai_total"]||"0"), 0)
				)

				vNilaiArr = vNilaitmpArr;
			}
		}
		setDatasumObj({
			nilai_terapi: vNetto,
			nilai_arr: vNilaiArr,
		});
	},[uDatamainArr,uDatamainArr.length])
	React.useEffect(()=>{
		/*//--LOAD_PER_PAGE--/
		if(uFirstload==="YA") return;

		setIDselect(0);
		setRowselect(-1);
		const vDatapageArr = uDatamainArr.filter(vItems=>parseInt(vItems.pg||0)===parseInt(uPageActive||1));
		if(vDatapageArr.length > 0) { 
			window.scrollTo({ top: 0, behavior: "smooth" });
			return;
		}

		apiLoaddata(uPageActive);
		//--END LOAD_PER_PAGE--*/

		//--LOAD_ALL_VIEW_PER_PAGE--/
		setIDselect(0);
		setRowselect(-1);
		//--END LOAD_ALL_VIEW_PER_PAGE--/
	},[uPageActive])//-->Unselect_ROW
	React.useEffect(()=>{
		if(!uHandelView) return;

		uHeaderActionObj.isHeaderView = false;
		uDispatch({type: "set", gInitHeaderAction: uHeaderActionObj});
		
		if(uHtml500msg) return;
		//console.log("(Lapterapi [uHandelView]) uHandelView => "+uHandelView)

		const vCabangID = localStorage.getItem("lastcabangid") || 
			(uDatacabangArr[0].id || "0");

		const vTanggalnowDT		= new Date();
		const vTanggalLastmonthDT 	= new Date();
		vTanggalLastmonthDT.setMonth(vTanggalLastmonthDT.getMonth() - 1);
		
		const vTglawalDT 		= new Date(vTanggalLastmonthDT.getFullYear(), vTanggalLastmonthDT.getMonth(), 26);
		const vTglakhirDT 		= new Date(vTanggalnowDT.getFullYear(), vTanggalnowDT.getMonth(), 25);

		/*//--TIDAK_DIPAKAI--/
		const vTglawalDT 		= new Date(vTanggalnowDT.getFullYear(), vTanggalnowDT.getMonth(), 1);
		const vTglakhirDT 		= new Date(vTanggalnowDT.getFullYear(), vTanggalnowDT.getMonth() + 1, 0);
		//--END TIDAK_DIPAKAI--*/
		
		const vTglawal 		= UFunc.DbDate(vTglawalDT);
		const vTglakhir 	= UFunc.DbDate(vTglakhirDT);

		setFormdataObj({
			cabang_id: uFilterObj.cabang_id || vCabangID,
			tgl_awal: uFilterObj.tgl_awal || vTglawal,
			tgl_akhir: uFilterObj.tgl_akhir || vTglakhir,
			terapimain_id: uFilterObj.terapimain_id || "0",
			thn: uFilterObj.thn || vTanggalnowDT.getFullYear(),
			jenis:"TANGGAL",
			init_change: 1
		});

		setHeaderDlgform("Pilih Filter Laporan")
		setDlgformshow(true)
	},[uHandelView])
	React.useEffect(()=>{
		if(!uHandelReset) return;

		uHeaderActionObj.isHeaderreset = false;
		uDispatch({type: "set", gInitHeaderAction: uHeaderActionObj});

		if(uHtml500msg) { apiLoadawal(); }
		else { setDataloaded(false); }
	},[uHandelReset])
	React.useEffect(()=>{
		if(!uIsDataloaded)
			{ initResettampilan(); return; }

		//--SET_TITLE--/
		let vTitelmain	= "Periode ";
		if(uFormdataObj.jenis === "BULAN") {
			vTitelmain += "BULAN <b>"+cBulanPanjang[parseInt(uFormdataObj.bln)-1]+" "+uFormdataObj.thn+"</b>";
		} else if(uFormdataObj.jenis === "TAHUN") {
			vTitelmain += "Tahun <b>"+uFormdataObj.thn+"</b>";
		} else {
			vTitelmain += 
				"<b>"+UFunc.TglAngka(uFormdataObj.tgl_awal)+"</b>"+
				" s.d. "+
				"<b>"+UFunc.TglAngka(uFormdataObj.tgl_akhir)+"</b>"+
				"";
		}

		const vCabangIdx= UFunc.getObjectIndeks(uDatacabangArr,uFormdataObj.cabang_id);
		let vTitelsub	= uDatacabangArr.length > 1 ? uDatacabangArr[vCabangIdx].cabang_nama+" &middot; " : "";
		if(parseInt(uFormdataObj.terapimain_id||"0") <= 0) 
			vTitelsub	+= "[SEMUA TERAPI]";
		else {
			const vTerapiIdx= UFunc.getObjectIndeks(uTerapimainArr,uFormdataObj.terapimain_id);
			vTitelsub	+= "<b>"+uTerapimainArr[vTerapiIdx].nama_terapi+"</b>";
		}

		//vTitelsub = "&middot; "+vTitelsub+" &middot;";
		setCaptionObj({title:vTitelmain,title_sub:vTitelsub});
		//--END SET_TITLE--/
	},[uIsDataloaded])
	React.useEffect(()=>{
		//console.log("(Lapterapi - [uIsDlgformshow]) uFilterObj => "+JSON.stringify(uFilterObj));
		if(!uIsDlgformshow) 
			{ setFormdataObj({}); return }

		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);

			const vButton = document.getElementById("btnDialogSimpan");
			vButton && (vButton.innerHTML = "Tampilkan");
			setElBtnsimpan(vButton);
			
			let vElfocus = document.getElementById("inpcabangid");
			if(!vElfocus) vElfocus = document.getElementById("inptglawal");

			if(!isMobile)
				vElfocus && vElfocus.focus();
		},350)
	},[uIsDlgformshow])
	React.useEffect(()=>{
		if(uDatamainArr.length <= 0) return;
		if(uPageActive > 1) setPageActive(1);
		else 
			{ setRowselect(-1); setIDselect(0); }

		if(JSON.stringify(uSortedObj||{}) === "{}") { return; }

		//console.log("(Lapterapi - [uSortedObj]) uSortedObj => "+JSON.stringify(uSortedObj));
		//console.log("(Lapterapi - [uSortedObj]) uDatamainArr => "+JSON.stringify(uDatamainArr));

		let vSortedArr;
		const vNamasort	= (uSortedObj.nama||"").toLowerCase();
		const vISNumeric= UFunc.isNumeric(uDatamainArr[0][vNamasort]);
		if(uSortedObj.jenis === "ASCENDING") {
			vSortedArr	= !vISNumeric
				? uDatamainArr.sort((a, b) => {
					return (a[vNamasort] > b[vNamasort]) ? 1 : ((b[vNamasort] > a[vNamasort]) ? -1 : 0) 
					}) 
				: uDatamainArr.sort((a, b) => a[vNamasort] - b[vNamasort]) ;
		}else if(uSortedObj.jenis === "DESCENDING") {
			vSortedArr	= !vISNumeric
				? uDatamainArr.sort((a, b) => {
					return (b[vNamasort] > a[vNamasort]) ? 1 : ((a[vNamasort] > b[vNamasort]) ? -1 : 0) 
				})
				: uDatamainArr.sort((a, b) => b[vNamasort] - a[vNamasort]);
		} else {
			vSortedArr	= uDatadefaultArr.slice(1);//.splice(0,1);
		}
		//console.log("(Lapterapi - [uSortedObj]) vSortedArr => "+JSON.stringify(vSortedArr));
		setDatamainArr(vSortedArr);
		setEfekview(!uEfekview);
	},[uSortedObj,
	uSortedObj.nama,
	uSortedObj.jenis,
	])
	
	//console.log("(Lapterapi) uActiveroute => "+(uActiveroute));
	if(UFunc.isEmpty(uTokenObj)) { prosesExpired(); return; }
	if(uHtml500msg) return (
		<CCard className="classbgcard">
		<CCardHeader className="fw-bolder">Page 500</CCardHeader>
		<CCardBody className="mx-md-5 p-md-5">
		<div className="fst-italic">
		{UFunc.renderHTML(uHtml500msg)}
		</div>
		</CCardBody>
		</CCard>
	)

	return (
		<>
		{(!uIsDataloaded) ? (
		<CCard className="classbgcard">
			<CCardHeader className="fw-bolder">Pilih Filter Laporan</CCardHeader>
			<CCardBody className="mx-md-5 p-md-5">
			<div className="mx-lg-5 px-lg-5 fst-italic classpetunjuk">
			*) Silahkan Pilih Filter, untuk menentukan Parameter Laporan yang akan Ditampilkan. Kemudian Tekan SIMPAN. Untuk Mencetak Silahkan KLIK Ikon Cetak..
			</div>
			</CCardBody>
		</CCard>
		) : (
		<CCard className="classbgcard">
			<CCardHeader className="d-flex justify-content-between px-1 px-md-3">
			<div>
				<div className="d-none d-md-block">{UFunc.renderHTML(uCaptionObj.title)}</div>
				<div className="d-md-none classfontsmaller"><small>{UFunc.renderHTML(uCaptionObj.title)}</small></div>
				<span className="classfontsmaller">
					<small className="classfontsmaller text-primary">
					{UFunc.renderHTML(uCaptionObj.title_sub)}
					</small>
				</span>
			</div>

			<div>
			<span className="d-none d-md-inline">
				<CTooltip content="--CETAK..">
				<CLink 
					className="classikon classikoncetak classcursorpointer"
					onClick={()=>hdlKlikCetak()}/>
				</CTooltip>

				<CTooltip content="--Export-2-Excel..">
				<CLink 
					className="classikon classikonexcel classcursorpointer"
					onClick={()=>hdlKlikExcel()}/>
				</CTooltip>
				
				<span className="mx-1">&middot;</span>
			</span>

			<span className="text-muted classfontsmaller">
				<small>{UFunc.formatAngka(uTimeelapse)} ms</small>
			</span>
			<span className="ms-1 d-md-none">&middot;</span>

			<CDropdown className="d-md-none">
				<CDropdownToggle caret={false} size="sm"
					className="p-0" color="transparent">
					<CIcon icon="cilChevronBottom" className="classikonbox mx-1" height={25}/>
				</CDropdownToggle>
				<CDropdownMenu>
					<CDropdownItem onClick={()=>hdlKlikCetak()}>
						<CIcon className="classikoncetak ms-0 me-2 align-middle" height={25}/>
						Cetak Laporan
					</CDropdownItem>
					<CDropdownItem onClick={()=>hdlKlikExcel()}>
						<CIcon className="classikonexcel ms-0 me-2 align-middle" height={25}/>
						Export-2-Excel
					</CDropdownItem>
				</CDropdownMenu>
			</CDropdown>
			</div>
			</CCardHeader>
			
			<CCardBody className="px-0">{contentLaporan()}</CCardBody>

			{(uJmlData > uMaxData) && (
				<CCardFooter>
				<MyPagination 
					activePage={uPageActive}
					pages={uJmlHal}
					onActivePageChange={(i)=>setPageActive(i)}
					align="start"/>
				</CCardFooter>
			)}
		</CCard>
		)}

		<MyDialogform
			options={{centered:true}}
			onSimpan={()=>hdlKlikDlgsimpan()}
			show={uIsDlgformshow} 
			dialogHeader={uHeaderDlgform}
			toggle={hdlToggleDlgform}
			renderContent={contentDlgform()}/>

		<iframe id="ifmcontentstoprint" className="d-none"/>
		</>
	)//>
}	

export default Lapterapi